<template>
    <div class="pc" :class="widClass">
        <!-- <div style="text-align: center;" >
          <img style="width: 60px;cursor: pointer;" src="../assets/images/promote.png"  @click="togglePromote">
          <div style="border-bottom: 2px solid #F56352; width: 160px; margin: auto;margin-top: -10px;"></div>
        </div> -->
        <div class="category" v-for="(cat, cindex) in cats" v-bind:key="cindex" :id="'cat-' + cindex">
            <div v-if="cindex === 1 & akPCAd === true" id="ad_mid" style="margin-top:20px; text-align: center;">
              <div style="width: 100%;text-align: center;">
                <!-- <Adsense
                  data-ad-client="ca-pub-4700907130335184"
                  data-ad-slot="1149013378">
                </Adsense> -->
              </div>
            </div>
            <div class="cat-header">
                <span class="title">{{cat.attrs.cname}}</span>
                <button class="op-btn" @click="toggleCatMode(cindex)" :class="{collapsed: cat.mode === 'collapse'}" v-if="cat.sites.length > 0">
                    <div class="op-btn-inner" v-if="cat.mode === 'collapse'"><span class="op-hint">收起分类</span><img class="op-arrow" src="../assets/images/up-arrow.png"></div>
                    <div class="op-btn-inner" v-else><span class="op-hint">展开分类</span><img class="op-arrow" src="../assets/images/down-arrow.png"></div>
                </button>
            </div>

<!--            <div v-if="cat.cat === 'aam'" class="cat-items-special-chart">-->
<!--                <div class="chart-btn" v-on:mouseover=" unfoldIndexChart = true" v-on:mouseout=" unfoldIndexChart = false" @click="loadIframe('index')" :style="{width: chartBtnWidth + 'px'}">-->
<!--                    <div class="holder">-->
<!--                    </div>-->
<!--                    <div class="source">-->
<!--                        <img src="../assets/images/chart.png" height=25 >-->
<!--                        <span style="padding-left: 10px;font-size: 18px; letter-spacing: 1px;" v-if="showIndexIframe === false">实时股市指数</span>-->
<!--                        <span style="padding-left: 10px;font-size: 18px; letter-spacing: 1px;" v-if="showIndexIframe === true">关闭股市指数</span>-->
<!--                    </div>-->
<!--                    <div class="holder">-->
<!--                        <img src="../assets/images/more-diluted.png" v-show="unfoldIndexChart === true & showIndexIframe === false">-->
<!--                        <img src="../assets/images/minimize-diluted.png" v-show="unfoldIndexChart === true & showIndexIframe === true">-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="chart-btn" v-on:mouseover=" unfoldDcoinChart = true" v-on:mouseout=" unfoldDcoinChart = false" @click="loadIframe('dcoin')" :style="{width: chartBtnWidth + 'px'}">-->
<!--                    <div class="holder">-->
<!--                    </div>-->
<!--                    <div class="source">-->
<!--                        <img src="../assets/images/chart.png" height=25 >-->
<!--                        <span style="padding-left: 10px;font-size: 18px; letter-spacing: 1px;" v-if="showDcoinIframe === false">加密货币行情</span>-->
<!--                        <span style="padding-left: 10px;font-size: 18px; letter-spacing: 1px;" v-if="showDcoinIframe === true">关闭货币行情</span>-->
<!--                    </div>-->
<!--                    <div class="holder">-->
<!--                        <img src="../assets/images/more-diluted.png" v-show="unfoldDcoinChart === true & showDcoinIframe === false">-->
<!--                        <img src="../assets/images/minimize-diluted.png" v-show="unfoldDcoinChart === true & showDcoinIframe === true">-->
<!--                        &lt;!&ndash;<span class="holder-hint" v-show="unfoldItem">点击展开</span>&ndash;&gt;-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="chart-btn blank" :style="{width: chartBtnWidth + 'px'}" v-show="widClass !== 'xxsmall' ">-->
<!--                    <span class="detail">行情数据 by <a href="https://cn.investing.com" rel="nofollow" target="_blank">Investing.com</a></span>-->
<!--                </div>-->

<!--                <div class="chart-btn blank" :style="{width: chartBtnWidth + 'px'}"  v-show="itemNum == 4">-->
<!--                </div>-->
<!--            </div>-->

            <div v-if="cat.cat === 'aam' & showIndexIframe === true" style="height: 360px; margin-top: 20px;">
                <iframe :src="iframeIndexUrl" width="100%" height="100%" frameborder="0" allowtransparency="true" marginwidth="0" marginheight="0" style="display:block;"></iframe>
            </div>

            <div v-if="cat.cat === 'aam' & showDcoinIframe === true" style="height: 460px; margin-top: 20px;">
                <iframe :src="iframeDcoinUrl" width="100%" height="100%" frameborder="0" allowtransparency="true" marginwidth="0" marginheight="0" style="display:block;"></iframe>
            </div>

            <div class="cat-items" v-for="i in cat.rc" v-bind:key="i">
                <div v-for="(site, sindex) in cat.sites.slice((i - 1) * itemNum, i * itemNum)" v-bind:key="sindex" @click="loadSite(cindex, (i - 1) * itemNum + sindex)">
                    <akitem :site="site" :pcindex="cindex" :psindex="(i - 1) * itemNum + sindex" :wclass="widClass" v-if="site.site !== 'aknull'" @reloadPcSite="reloadSite" @miniPcSite="miniSite"></akitem>
                    <aknull v-else></aknull>
                </div>
            </div>
        </div>

        <!-- <div v-if="bespoke === true" id="ad_bespoke_mid" style="margin-top:35px; text-align: center;">

        </div> -->
        <!-- <div style="margin-top:35px;width: 100%; float:center;text-align: center;">
          <Adsense
              data-ad-client="ca-pub-4700907130335184"
              data-ad-slot="1149013378">
          </Adsense>
        </div> -->
        <!-- <div class="side" v-show="widClass !== 'xxsmall' && widClass !== 'xsmall'">
            <div class="s-item copytool" @click="toggleCopytool">
            </div>
            <div class="s-item feedback" @click="toggleFeedback">
            </div>
            <div class="s-item about" @click="toggleAbout">
            </div>
            <div class="s-item support" @click="togglePromote">
            </div>
        </div>
        <div class="modal-box" v-if="showModal === true" @keyup.esc="closeModals" tabindex="0">
            <div v-if="showFeedBack">
                <feedback></feedback>
                <div class="close-box">
                    <img class="close-img" src="../assets/images/close.png"  @click="toggleFeedback">
                </div>
            </div>
            <div v-if="showSupport">
                <support @closePromoteModal="closePromoteModal"></support>
                <div class="close-box">
                    <img class="close-img" src="../assets/images/close.png"  @click="toggleSupport">
                </div>
            </div>
        </div> -->

        <div v-if="showPromote">
          <div class="modal-box">
            <promote @closePromoteModal="closePromoteModal"></promote>
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import akitem from '../components/AKItem.vue'
import aknull from '../components/AKNull'
import feedback from '../components/FeedBack'
import support from '../components/Support'
import promote from '../components/Promote'
/* eslint-disable */
export default {
  name: "pc",
  data() {
    return{
      widClass: 'small',
      itemNum: 3,
      cats: [],
      showModal: false,
      showFeedBack: false,
      showSupport: false,
      showDevLog: false,
      showPromote: false,
      beatIter: 0, //beat iter值，之和
      iters:{}, //所有站点的iter值dict
      bespoke: false, //是否为定制化显示
      unfoldIndexChart: false,
      unfoldDcoinChart: false,
      showIndexIframe: false,
      showDcoinIframe: false,
      iframeIndexUrl: '',
      iframeDcoinUrl: '',
      chartBtnWidth: 350,
      akPCAd: true
    }
  },
  components: {
    aknull,
    akitem,
    feedback,
    support,
    promote
  },
  beforeCreate: function () {
  },
  computed: {
    // computed 不支持传递参数需要用method
    // itemMode: function (cindex, sindex) {
    //   console.log(cindex)
    //   if(this.cats[cindex].mode === 'collapse' || this.cats[cindex].sites[sindex].mode === 'collapse'){
    //     // 分类应该一直是mini，直到分类下面所有的site状态都变为collapse之后，分类变为collapse
    //     return 'collapse'
    //   }
    //   else{
    //     return 'mini'
    //   }
    // }
  },
  created: function () {
    //设置chartBtnWidth
    if(this.widClass === 'xsmall'){
      this.chartBtnWidth = 310
    }
    else{
      this.chartBtnWidth = 350
    }

    this.setWidPara()
    window.addEventListener('resize', this.setWidPara);
    // window.onresize = function(event) {
    //   this.setWidPara()
    // };
    var that = this
    this.$http.get('/boot', {}, function (r) {
      if (r.status === 0) {
        // 计算处理分类数据
        var _cats = r.data.cats
        for(var i =0; i < _cats.length; i++){
            // 设置初始显示模式
            _cats[i].mode = 'mini'
            // 设置初始数据状态
            _cats[i].inited = false
            // 设置每个site的初始mode
            for(var j = 0; j < _cats[i]['sites'].length; j++){
              _cats[i]['sites'][j].mode = 'mini'
              _cats[i]['sites'][j].inited = false
              _cats[i]['sites'][j].dofresh = false
            }
            _cats[i]['rc'] = Math.ceil(_cats[i]['sites'].length / that.itemNum)
            //计算需要填充的空item数目
            var _nullNum = 0
            if(_cats[i]['sites'].length % that.itemNum !== 0){
              _nullNum = that.itemNum - _cats[i]['sites'].length % that.itemNum
            }
            var k = 0
            while(k < _nullNum){
              _cats[i]['sites'].push({'site': 'aknull'})
              k++
            }
        }
        that.cats = _cats
        that.iters = r.data.iters
        that.beatIter = r.data.alliter
        that.bespoke = r.data.bespoke
        if('mods' in r.data){
          that.akPCAd = r.data.mods.ak_pc_ad
        }
        if(that.bespoke){
          setInterval(that.refreshCheck, 120000)
        }
        else{
          setInterval(that.refreshCheck, 100000)
        }
      }
    })
  },
  mounted: function( ){
  },
  destroyed() {
    window.removeEventListener('resize',this.setWidPara);
  },
  methods: {
    loadIframe: function (iname){
      var iframe = ''
      if(iname === 'index'){
        if(this.iframeIndexUrl === ''){
          this.iframeIndexUrl = 'https://cn.widgets.investing.com/live-indices?theme=darkTheme&pairs=959206,179,166,178,27,170,1118193'
        }
        this.showIndexIframe = !this.showIndexIframe
      }
      else if(iname === 'dcoin'){
        if(this.iframeDcoinUrl === ''){
          this.iframeDcoinUrl = 'https://cn.widgets.investing.com/top-cryptocurrencies?theme=darkTheme'
        }
        this.showDcoinIframe = !this.showDcoinIframe
      }
    },
    setWidPara: function (){
      // var _width = screen.width
      var _width = document.body.clientWidth
      //ipad resolution
      //Portrait: 768x946
      //Landscape: 1024x690
      if(_width <= 770){
        this.itemNum = 2
        this.widClass = 'xxsmall'
        this.chartBtnWidth = 350
      }
      else if(_width <= 1150){
        this.itemNum = 3
        this.widClass = 'xsmall'
        this.chartBtnWidth = 310
      }
      else if(_width <= 1500){
        this.itemNum = 3
        this.widClass = 'small'
          this.chartBtnWidth = 350
      }
      else if(_width <= 2050){
        this.itemNum = 4
        this.widClass = 'middle'
        this.chartBtnWidth = 350
      }
      else{
        this.itemNum = 4
        this.widClass = 'large'
        this.chartBtnWidth = 350
      }
    },
    loadSite: function (cindex, sindex) {
      var _site = this.cats[cindex].sites[sindex]
      var that = this
      // 仅当 site 状态为 mini 时，展开需要加载数据，否则不需要
      if(_site.site !== 'aknull'){
        if(_site.inited === false){
          this.$http.get('/sites/' + _site.site, {}, function (r) {
            if (r.status === 0) {
              var _site = r.data.site
              _site.inited = true
              _site.mode = 'collapse'
              _site.dofresh = false
              Vue.set(that.cats[cindex].sites, sindex, _site)
              //检测是否需要更改对应分类的inited以及mode状态
              that.checkCat(cindex)
            }
          })
        }
        else{
          Vue.set(that.cats[cindex].sites[sindex], 'mode', 'collapse')
          //检测是否需要更改对应分类的inited以及mode状态
          that.checkCat(cindex)
        }
      }
    },
    miniSite: function(cindex, sindex) {
      // Vue.set(this.cats[cindex].sites[sindex], 'mode', 'mini')
      Vue.set(this.cats[cindex].sites[sindex], 'mode', 'mini')
      console.log("Minisite from child, cindex: " + cindex + ', sindex: ' + sindex)
      console.log('mode ' + this.cats[cindex].sites[sindex].mode)
      this.checkCat(cindex)
    },
    checkCat: function (cindex) {
      // 增加允许用户单独load站点的功能后，load之后需要检查分类的状态
      // 检查该分类下面的site是否已经全部打开或者全部加载完成
      var _un_inited = 0
      var _un_collapsed = 0
      for(var i = 0; i < this.cats[cindex].sites.length; i++){
        if(this.cats[cindex].sites[i].site !== 'aknull') {
          if(this.cats[cindex].sites[i].inited === false){
            _un_inited++
          }
          if(this.cats[cindex].sites[i].mode === 'mini'){
            _un_collapsed++
          }
        }
      }
      //该分类下的所有站点均已经inited
      if(_un_inited === 0){
        Vue.set(this.cats[cindex], 'inited', true)
      }
      else{
        Vue.set(this.cats[cindex], 'inited', false)
      }
      //该分类下的所有站点均已经展开
      if(_un_collapsed === 0){
        Vue.set(this.cats[cindex], 'mode', 'collapse')
      }
      else{
        Vue.set(this.cats[cindex], 'mode', 'mini')
      }
    },
    testRefresh: function () {
      Vue.set(this.cats[0].sites[2], 'dofresh', true)
    },
    refreshCheck: function (){
      //定时检查是否需要更新
      // console.log('refresh check')
      var that = this
      if(this.bespoke){
        this.$http.get('/bespoke/beat', {}, function (r) {
            //直接检测更新
            that.iters = r.data.iters
            //遍历cats数据设置更新提醒
            for(var i =0; i < that.cats.length; i++){
              for(var j =0; j < that.cats[i].sites.length; j++){
                //site原数据的iter值与最新的iter值不相等，排除掉 aknull, 仅当某个站点数据已经初始化之后 才发送设置更新提醒
                if(that.cats[i].sites[j].site !== 'aknull' && that.cats[i].sites[j].inited === true && (that.cats[i].sites[j].attrs.iter < that.iters[that.cats[i].sites[j].site]))
                {
                  //设置为最新的iter值
                  Vue.set(that.cats[i].sites[j].attrs, 'iter', that.iters[that.cats[i].sites[j].site])
                  Vue.set(that.cats[i].sites[j], 'dofresh', true)
                }
              }
            }
        })
      }
      else{
        //非bespoke时调用原先逻辑
        this.$http.get('/beat?citer=' + this.beatIter, {}, function (r) {
          if (r.data.refresh === true) {
            //需要更新
            that.iters = r.data.iters
            that.beatIter = r.data.alliter
            //遍历cats数据设置更新提醒
            for(var i =0; i < that.cats.length; i++){
              for(var j =0; j < that.cats[i].sites.length; j++){
                //site原数据的iter值与最新的iter值不相等，排除掉 aknull, 仅当某个站点数据已经初始化之后 才发送设置更新提醒
                if(that.cats[i].sites[j].site !== 'aknull' && that.cats[i].sites[j].inited === true && (that.cats[i].sites[j].attrs.iter < that.iters[that.cats[i].sites[j].site]))
                {
                  //设置为最新的iter值
                  Vue.set(that.cats[i].sites[j].attrs, 'iter', that.iters[that.cats[i].sites[j].site])
                  Vue.set(that.cats[i].sites[j], 'dofresh', true)
                }
              }
            }
          }
        })
      }
    },
    //触发子组件更新父组件数据
    reloadSite: function(cindex, sindex, sdata){
      Vue.set(this.cats[cindex].sites, sindex, sdata)
      console.log("from child, cindex: " + cindex + ', sindex: ' + sindex)
    },
    toggleCopytool: function () {
      window.location.href =  'https://cp.anyknew.com'
    },
    closePromoteModal: function(){
      this.showModal = false
      this.showPromote = false
    },
    toggleFeedback: function (){
        this.showModal = !this.showModal
        this.showFeedBack = !this.showFeedBack
    },
    toggleAbout: function () {
      window.location.href =  'https://www.anyknew.com/board/notifications'
    },
    togglePromote: function() {
        this.showModal = !this.showModal
        this.showPromote = !this.showPromote
    },
    toggleSupport: function() {
        this.showModal = !this.showModal
        this.showSupport = !this.showSupport
    },
    closeModals: function () {
      this.showModal = false
      this.showDevLog = false
      this.showFeedBack = false
      this.showSupport = false
    },
    toggleCatMode: function (cindex) {
      if(this.cats[cindex].mode === 'mini'){
        // 判断当前分类是否已经加载了数据，若没有加载数据，加载该分类下数据
        if(this.cats[cindex].inited === false){
          var that = this
          var _cat_url = '/cats/' + this.cats[cindex]['cat']
          if(this.bespoke){
            _cat_url = '/bespoke/cats/' + this.cats[cindex]['cat']
          }
          this.$http.get(_cat_url, {}, function (r) {
            if (r.status === 0) {
              // that.cats[index] = r.data.cat
              var _cat = r.data.cat
              // _cat['rc'] = Math.ceil(_cat['sites'].length / that.itemNum)
              // //遍历设置初始sites.refresh状态
              // for(var j = 0; j < _cat['sites'].length; j++){
              //   _cat['sites'][j].dofresh = false
              // }
              // var _nullNum = 0
              // if(_cat['sites'].length % that.itemNum !== 0){
              //   _nullNum = that.itemNum - _cat['sites'].length % that.itemNum
              // }
              // var j = 0
              // while(j < _nullNum){
              //   _cat['sites'].push({'site': 'aknull'})
              //   j++
              // }
              // 挨个检查该分类下sites是否已经初始化，如果已经初始化则不需要再保存对应的站点数据
              for(var j = 0; j < that.cats[cindex].sites.length; j++){
                if(that.cats[cindex].sites[j].inited === false){
                  var _site = _cat.sites[j]
                  _site.inited = true
                  _site.mode = 'collapse'
                  _site.dofresh = false
                  Vue.set(that.cats[cindex].sites, j, _site)
                }
                else{
                  // 如果数据已经初始化，仅设置mode为'collapse'
                  Vue.set(that.cats[cindex].sites[j], 'mode', 'collapse')
                }
              }
              that.cats[cindex].inited = true
              that.cats[cindex].mode = 'collapse'
            }
          })
        }
        else{
          //设置cat状态为展开
          Vue.set(this.cats[cindex], 'mode', 'collapse')
          //设置每个 site 状态为展开
          for(var j = 0; j < this.cats[cindex].sites.length; j++){
            Vue.set(this.cats[cindex].sites[j], 'mode', 'collapse')
          }
        }
      }
      else{
        Vue.set(this.cats[cindex], 'mode', 'mini')
        //设置每个 site 状态为展开
        for(var j = 0; j < this.cats[cindex].sites.length; j++){
          Vue.set(this.cats[cindex].sites[j], 'mode', 'mini')
        }
      }
    }
  }
}
</script>

<style lang="less">
    .pc{
        width: 100%;
        min-height: 100%;
        margin: auto;
        position: relative;
        .side{
            position: fixed;
            top: 50%;
            right: 20px;
            transform:translateY(-50%);
            .s-item{
                width: 40px;
                height: 40px;
                border-radius: 5px;
                margin-bottom: 8px;
                background-color: #FFFFFF;
                cursor: pointer;
                &.support {
                    margin-top: 20px;
                    background-color: #3DB4F1;
                    background-image: url("../assets/images/charge-i.png");
                    background-size: 25px 25px;
                    background-position: center;
                    background-repeat: no-repeat;

                    &:hover {
                        background-image: url("../assets/images/charge-i.png");
                    }
                }
                &.copytool{
                    background-image: url("../assets/images/copytool.png");
                    background-size: 25px 25px;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background-color: #3DB4F1;
                        background-image: url("../assets/images/copytool-i.png");
                    }
                }
                &.about{
                    background-image: url("../assets/images/akicon.png");
                    background-size: 25px 25px;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background-color: #3DB4F1;
                        background-image: url("../assets/images/akicon-i.png");
                    }
                }
                &.feedback{
                    background-image: url("../assets/images/feedback.png");
                    background-size: 25px 25px;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background-color: #3DB4F1;
                        background-image: url("../assets/images/feedback-i.png");
                    }
                }
                &.devlog{
                    background-image: url("../assets/images/calendar.png");
                    background-size: 25px 25px;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background-color: #3DB4F1;
                        background-image: url("../assets/images/calendar-i.png");
                    }
                }
            }
        }
        .right-corner{

            position: fixed;
            bottom: 100px;
            right: 20px;

            .s-item {
                width: 40px;
                height: 40px;
                /*border-radius: 5px;*/
                background-color: #FFFFFF;
                cursor: pointer;
            }
        }
        .modal-box{
            position: fixed;
            z-index: 4700;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .7);
            display: table;
            transition: opacity .3s ease;
            .close-box{
                cursor: pointer;
                margin-top: 50px;
                text-align: center;
                .close-img{
                    width: 25px;
                }
            }
        }
        &.xxsmall{
            width: 740px;
        }
        &.xsmall{
            width: 990px;
        }
        &.small{
            width: 1120px;
        }
        &.middle{
            width: 1520px;
        }
        &.large{
            width: 1900px;
        }
        .category{
            width: 100%;
            .cat-header{
                display: flex;
                align-items: center;
                justify-content: left;
                width: 100%;
                padding-top: 20px;
                .title{
                    flex: 1;
                    font-size: 1.2rem;
                }
                .op-btn{
                    position: relative;
                    padding: 3px 20px;
                    border-radius: 3px;
                    background-color: #3DB4F1;
                    border: 1px solid #3DB4F1;
                    color: #FFFFFF;
                    &.collapsed{
                        background-color: #f8f8f8;
                        border: 1px solid #3DB4F1;
                        color: #3DB4F1;
                    }
                    .op-btn-inner{
                        display: flex;
                        align-items: center;
                        .op-hint {
                            font-size: 0.7rem;
                        }
                        .op-arrow{
                            margin-left: 5px;
                            width: 12px;
                            height: 12px;
                        }
                    }
                }
            }
            .cat-items{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding-top: 20px;
            }
            .cat-items-special-chart{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding-top: 20px;
                .chart-btn{
                    width: 350px;
                    background-color: #FFFFFF;
                    border-radius: 5px;
                    padding: 10px 0;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    .holder{
                        width: 30px;
                        .holder-hint{
                            color: #999999;
                            font-size: 0.7rem;
                        }
                        img{
                            height: 20px;
                        }
                    }
                    .source{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex: 1;
                        text-align: center;
                    }
                    &.blank{
                        background-color: #f8f8f8;
                        .detail{
                            color:#999999;
                            font-size: 13px;
                            a{
                                color: #999999;
                            }
                            a:hover{
                                color: #3DB4F1;
                            }
                        }
                    }
                }
            }
        }
    }

</style>